export default "__VITE_ASSET__CgGqlK$X__"